export const FilterKinds = ["directManagers", "reportingLine", "segment", "department", "gender", "workLocation", "roleLevel", "jobTitle", "tenure", "track"] as const;

export type FilterKind = (typeof FilterKinds)[number];
